package com.nonopn.skydome.common.app.pages.estimate

import androidx.compose.foundation.isSystemInDarkTheme
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.material.LocalContentColor
import androidx.compose.runtime.Composable
import androidx.compose.runtime.CompositionLocalProvider
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.ui.Modifier
import com.nonopn.skydome.common.app.api.Mode
import com.nonopn.skydome.common.app.api.impl.ThunderDetectionEstimate
import com.nonopn.skydome.common.app.home.AppModel
import com.nonopn.skydome.common.app.home.HotPreviewApp
import com.nonopn.skydome.common.app.home.LocalIsPreview
import com.nonopn.skywatcher.design.theme.AppColor
import de.drick.compose.hotpreview.HotPreview
import eu.codlab.compose.theme.LocalDarkTheme
import eu.codlab.viewmodel.rememberViewModel

@Composable
fun EstimateScreen(
    modifier: Modifier,
    appModel: AppModel,
    mode: Mode,
    existingEstimate: ThunderDetectionEstimate? = null,
) {
    val scope = rememberCoroutineScope()

    val model = if (LocalIsPreview.current) {
        FakeEstimateScreenModel(false)
    } else {
        rememberViewModel { EstimateScreenModelImpl(appModel, mode, existingEstimate) }
    }

    LaunchedEffect(mode) {
        model.updateCurrentInterface(mode)
    }

    model.scope = scope

    val color = if (LocalDarkTheme.current) {
        AppColor.WhiteCream
    } else {
        AppColor.BackgroundBlue
    }

    CompositionLocalProvider(
        LocalContentColor provides color
    ) {
        Column(modifier) {
            EstimateMap(Modifier.weight(1.0f).fillMaxWidth(), model)
        }
    }
}

@HotPreview(widthDp = 1200, heightDp = 800, darkMode = true)
@HotPreview(widthDp = 1200, heightDp = 800, darkMode = false)
@Composable
private fun EstimateScreenPreview() {
    HotPreviewApp(
        Modifier.fillMaxSize(),
        isDarkTheme = isSystemInDarkTheme(),
        isPreview = true
    ) {
        EstimateScreen(
            Modifier.fillMaxSize(),
            AppModel.fake(),
            Mode.Normal
        )
    }
}
